
import * as $ from 'jquery';

import * as NullUtil from '../../NullUtil';

require('jquery-ui/ui/widgets/tooltip');

// This is the jquery-visible plugin that has been amd-ified to work with require and webpack
require('src/shared/jqueryExtensions/visible');

// Constant used for tooltip Fade Time
const tooltipFadeTime = 400;

/** Enable tooltips */
export function enableTooltips(): void {
     if ($(document.body).hasClass('ally-tooltips-enabled')) {
        return;
    }
    // Adds a class to the document body to indicate tooltips are enabled.
    $(document.body).addClass('ally-tooltips-enabled');

    // Sets up an event listener for 'allytooltipopen' to add the scroll listener when a tooltip is opened.
    $(document).on('allytooltipopen', addScrollListener);

    // Explicitly triggers the 'allytooltipopen' event to immediately execute the tooltip open logic.
    $(document).trigger('allytooltipopen');


    /** Removes tooltip when Escape key is down. */
    $(window).on('keydown', (event) => {
        if (event.key === 'Escape') {
            $('.ally-tooltip').fadeOut(400, function() {
                $(this).remove();
            });
        }
    });

    $(document).tooltip(tooltipOptions());

    // The jQuery UI tooltip library adds an aria-live div element to the DOM that allows screenreaders to read out
    // tooltips. It gives this div a `ui-helper-hidden-accessible` CSS class which hides the content from the
    // presentation layer, but still allows it to be read out by screenreaders. Remove the class and apply our own
    // as the jQuery UI CSS is not included and we should not rely on the LMS to provide it.
    $('div.ui-helper-hidden-accessible:last-of-type')
        .removeClass('ui-helper-hidden-accessible')
        .addClass('ally-helper-hidden-accessible');
}

/** Removes any tooltips that might be present in the DOM immediately. */
export async function clearAllTooltips(): Promise<void> {
    await new Promise((resolve) => {
        $('.ally-tooltip').remove();
        resolve();
    });
}

// Define the scroll handler function
function handleScroll() {
    $('.ally-tooltip').fadeOut(tooltipFadeTime, function() {
        // Reset the JQuery tooltip to fix issue with aria-describedby
        $(document).tooltip('disable');
        $(document).tooltip('enable');
    });
}

function addScrollListener() {
    window.removeEventListener('scroll', handleScroll, true); // Remove any existing scroll listener
    window.addEventListener('scroll', handleScroll, true); // Add the scroll listener
}

function tooltipOptions() {
    const verticalOffset = 15;
    const tooltipVerticalPadding = 25;
    const tooltipHorizontalPadding = 15;
    const options: JQueryUI.TooltipOptions = {
        'content'() {
            const el = this as HTMLElement;
            const content = NullUtil.firstOrNull(
                () => el.getAttribute('title'),
                () => el.getAttribute('data-title'),
                () => el.getAttribute('aria-label'));
            return NullUtil.orElse<string>(content, '').replace(/\n/g, '<br>');
        },
        'items': '.ally-add-tooltip',
        'position': {
            'at': 'center top',
            'my': `center bottom-${verticalOffset}`,
            'using': (position: any, feedback: any) => {
                setTimeout(() => {
                    resolvePosition(feedback, verticalOffset, tooltipVerticalPadding, tooltipHorizontalPadding);
                }, 50);
            }
        },
        'close': (event, ui) => {
            ui.tooltip.hover(
                function () {
                    $(this).stop(true).fadeTo(tooltipFadeTime, 1);
                },
                function () {
                    $(this).fadeOut(tooltipFadeTime, function () { $(this).remove(); });
                }
            );
        },
        'open': (event, ui) => {
            removejQueryUiClasses((ui as any).tooltip);
            removejQueryUiClasses((ui as any).tooltip.find('*'));
        }
    };

    (options as any).classes = { 'ui-tooltip': 'ally-tooltip' };

    return options;
}

function resolvePosition(
    feedback: any,
    verticalOffset: number,
    tooltipVerticalPadding: number,
    tooltipHorizontalPadding: number
) {
    const $tooltip = $(feedback.element.element).css({ 'position': 'fixed' });
    const tooltipWidth = NullUtil.orElse<number>($tooltip.outerWidth(), 0);
    const tooltipHeight = NullUtil.orElse<number>($tooltip.outerHeight(), 0);

    const $targetEl = getTargetElement(feedback);
    const targetDetails = getTargetElementDetails($targetEl);

    setTooltipPosition($tooltip, $targetEl, targetDetails, tooltipWidth, tooltipHeight, verticalOffset, tooltipVerticalPadding);
    const tooltipVisibility = ($tooltip as any).visible();

    addArrowToTooltip($tooltip, $targetEl);

    if (!tooltipVisibility.isEntirelyVisible) {
        adjustTooltipPosition(
            $tooltip,
            $targetEl,
            tooltipVisibility,
            targetDetails,
            tooltipWidth,
            tooltipHeight,
            verticalOffset,
            tooltipHorizontalPadding
        );
    }

    $tooltip.css('visibility', 'visible');
}

function getTargetElement(feedback: any): JQuery<HTMLElement> {
    let $targetEl = $(feedback.target.element);
    const $centerOnEl = $targetEl.find('.ally-tooltip-center');
    if ($centerOnEl.length !== 0) {
        $targetEl = $centerOnEl;
    }
    return $targetEl;
}

function getTargetElementDetails($targetEl: JQuery<HTMLElement>) {
    const targetElWidth = NullUtil.orElse<number>($targetEl.outerWidth(), 0);
    const targetElHeight = NullUtil.orElse<number>($targetEl.outerHeight(), 0);
    const targetElOffset = $targetEl[0].getBoundingClientRect();
    const targetElCenterX = targetElOffset.left + (targetElWidth / 2);
    const targetElCenterY = targetElOffset.top + (targetElHeight / 2);

    return { targetElWidth, targetElHeight, targetElOffset, targetElCenterX, targetElCenterY };
}

function setTooltipPosition(
    $tooltip: JQuery<HTMLElement>,
    $targetEl: JQuery<HTMLElement>,
    targetDetails: any,
    tooltipWidth: number,
    tooltipHeight: number,
    verticalOffset: number,
    tooltipVerticalPadding: number
) {
    if ($targetEl.hasClass('ally-tooltip-under-element')) {
        $tooltip.addClass('ally-tooltip-under');
        $tooltip.css({
            'top': `${targetDetails.targetElOffset.bottom + verticalOffset}px`,
            'left': `${targetDetails.targetElCenterX - (tooltipWidth / 2)}px`
        });
    } else {
        $tooltip.css({
            'left': `${targetDetails.targetElCenterX - (tooltipWidth / 2)}px`,
            'top': `${targetDetails.targetElCenterY - tooltipHeight - tooltipVerticalPadding}px`
        });
    }
}

function addArrowToTooltip($tooltip: JQuery<HTMLElement>, $targetEl: JQuery<HTMLElement>) {
    $('<div>')
        .addClass('ally-arrow')
        .appendTo($tooltip);

    if ($targetEl.hasClass('ally-tooltip-under-element')) {
        $('.ally-arrow').addClass('ally-arrow-top');
    }
}

function adjustTooltipPosition(
    $tooltip: JQuery<HTMLElement>,
    $targetEl: JQuery<HTMLElement>,
    tooltipVisibility: any,
    targetDetails: any,
    tooltipWidth: number,
    tooltipHeight: number,
    verticalOffset: number,
    tooltipHorizontalPadding: number
) {
    const targetElImage = $targetEl.find('img');
    const targetElImageWidth = NullUtil.orElse<number>(targetElImage.outerWidth(), targetDetails.targetElWidth);
    const targetElImageHeight = NullUtil.orElse<number>(targetElImage.outerHeight(), 0);
    const windowHeight = NullUtil.orElse<number>($(window).outerHeight(), 0);

    if (targetDetails.targetElOffset.bottom + 75 < windowHeight &&
        tooltipVisibility.leftVisible && tooltipVisibility.rightVisible) {
        const top = (targetDetails.targetElCenterY + targetElImageHeight / 2 + verticalOffset);
        $tooltip.css({ 'top': `${top}px` });
        $('.ally-arrow').addClass('ally-arrow-bottom');
    } else if (tooltipVisibility.leftVisible) {
        const left = (targetDetails.targetElCenterX - tooltipWidth - targetElImageWidth / 2 - tooltipHorizontalPadding);
        const top = (targetDetails.targetElCenterY - tooltipHeight / 2);
        $tooltip.css({
            'left': `${left}px`,
            'top': `${top}px`
        });
        $('.ally-arrow').addClass('ally-arrow-right');
    } else if (tooltipVisibility.rightVisible) {
        const left = (targetDetails.targetElCenterX + targetElImageWidth / 2 + tooltipHorizontalPadding);
        const top = (targetDetails.targetElCenterY - tooltipHeight / 2);
        $tooltip.css({
            'left': `${left}px`,
            'top': `${top}px`
        });
        $('.ally-arrow').addClass('ally-arrow-left');
        /* istanbul-ignore-else */
    } else {
        const top = (targetDetails.targetElOffset.bottom + verticalOffset);
        $tooltip.css({
            'top': `${top}px`,
            'left': `${targetDetails.targetElCenterX - (tooltipWidth / 2)}px`
        });
        $('.ally-arrow').addClass('ally-arrow-top');
    }
}

/**
 * Removes any jQuery UI CSS classes from a given element. A jQuery UI class is any classname that's prefixed with
 * `ui-`.
 *
 * @param $el    The element to remove the CSS classes from
 */
function removejQueryUiClasses($el: JQuery<HTMLElement>) {
    const uiClasses = NullUtil.orElse<string>($el.attr('class'), '')
        .split(' ')
        .filter((c) => (c.indexOf('ui-') === 0))
        .join(' ');
    $el.removeClass(uiClasses);
}
